module.exports = __webpack_public_path__ + "img/dCarbonIcon.56c95d5f.png";